import { SharedSliceRenderer } from "@prismicio/api-renderer"
import {
  type ApiDocument,
  LinkResolver,
  type RenderContext,
} from "@prismicio/api-renderer/lib/models"
import type {
  SharedSlice as SharedSliceAPI,
  SliceZone,
} from "@prismicio/client"
import type { SharedSliceContent } from "@prismicio/types-internal/lib/content"
import type { SharedSlice } from "@prismicio/types-internal/lib/customtypes"

// The Simulator requires a slice in the API format.
export function renderAPISlice(
  sliceModel: SharedSlice,
  content: SharedSliceContent,
): SliceZone<SharedSliceAPI> {
  const rendered = SharedSliceRenderer(renderContext).renderV2(
    sliceModel,
    content,
  ) as SharedSliceAPI

  return [
    {
      ...rendered,
      id: sliceModel.id,
      slice_type: sliceModel.id,
    },
  ]
}

const renderContext: RenderContext = {
  Extension: undefined, // Will render document links with a "broken" type, as we don't support them in the simulator.
  urlRewriter: {
    optimizeImageUrl(originUrl: string) {
      return originUrl
    },
    rewriteImageUrl(view) {
      return view.url || "/mockURL"
    },
    rewriteFileUrl(originUrl: string) {
      return originUrl
    },
    rewriteS3Bucket(url: string) {
      return url
    },
    enforceCDN(url: string) {
      return url
    },
  },
  emptyStringInsteadOfNull: false,
  LinkResolver: {
    buildUrl(_params: {
      linkResolver: LinkResolver | undefined
      pageType: string
      doc?: ApiDocument
    }): string | undefined | null {
      return "/"
    },
  },
}
